import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { Utils } from '../../utils/utils';

interface ProtectedAdminRouteProps {
    children: React.ReactNode;
    requireSuperAdmin?: boolean;
}

export const ProtectedAdminRoute: React.FC<ProtectedAdminRouteProps> = ({
    children,
    requireSuperAdmin = false,
}) => {
    const { user } = useAuth();
    const location = useLocation();

    // Check if user is authenticated
    if (!user) {
        // Store the current URL for redirect after login
        const redirectUrl = encodeURIComponent(location.pathname + location.search);
        return <Navigate to={`/sign-in?redirect=${redirectUrl}`} replace />;
    }

    // Check if user has platform admin rights
    if (!Utils.userIsPlatformAdmin(user)) {
        return <Navigate to="/dashboard" replace />;
    }

    // If super admin is required, check for super admin role
    if (requireSuperAdmin && !Utils.userIsSuperAdmin(user)) {
        return <Navigate to="/admin/dashboard" replace />;
    }

    return <>{children}</>;
};